<template>
	<div class="max-w-4xl mx-auto px-4 py-8 text-ihh-midnight-gray">
		<!-- Header Section -->
		<h1 class="text-3xl font-bold text-center mb-10">New Birth Kit Setup</h1>

		<!-- Overview Section -->
		<div>
			<h2 class="text-xl font-bold mb-4">📦 Custom Birth Kits for Midwives</h2>
			<p class="text-lg mb-8">
				At <span class="italic">In His Hands Birth Supply</span>, we make it easy for midwives to create and manage
				<span class="font-semibold">custom birth kits</span> tailored to their unique practice and the needs of their clients.
			</p>
		</div>

		<!-- Benefits Section -->
		<div class="mb-10">
			<h2 class="text-xl font-bold mb-4">✅ Why Choose Our Custom Birth Kits?</h2>
			<ul class="space-y-3 list-disc pl-5">
				<li><span class="font-semibold">100% Customizable</span> — You choose exactly what goes in each kit</li>
				<li><span class="font-semibold">Easy Reordering</span> — Clients can order online anytime with your unique kit link</li>
				<li><span class="font-semibold">Time-Saving</span> — No more printing supply lists or managing inventory</li>
				<li><span class="font-semibold">Midwife-First Support</span> — Built for midwives with first class customer service</li>
				<li><span class="font-semibold">Easy Editing - NEW</span> — Now you can create & modify your own custom birth kit anytime from your online account.</li>
				<li><span class="font-semibold">Reliable Inventory</span> — Professionally packed with quality supplies we stock year-round</li>
				<li><span class="font-semibold">No Setup Fees</span> — Creating a kit is completely 100% free</li>
			</ul>
		</div>

		<!-- How-To Section -->
		<div class="mb-10">
			<h2 class="text-xl font-bold mb-4">🛠 How to Create A New Custom Birth Kit</h2>
			<ol class="list-decimal list-inside space-y-3 pl-4">
				<li class="space-x-1">
					<span class="font-semibold">Log in or create an account</span><router-link to="/account" class="text-ihh-dark-salmon hover:underline">here</router-link>
				</li>
				<li>
					Go to <span class="font-semibold">Birth Kits</span> on your account
					<router-link to="/account/birth-kits" class="text-ihh-dark-salmon hover:underline">page</router-link>
				</li>
				<li>Click <span class="font-semibold">"New Birth Kit"</span></li>
				<li>Name your kit</li>
				<li>Add your logo</li>
				<li>Search our entire catalog and add the birth kit default and optional items you would like your clients to have on hand for the birth</li>
				<li>Submit your kit for approval <span class="italic">(usually takes just a few hours!)</span></li>
				<li>Once approved, you can share your kit link with your clients for easy ordering</li>
				<li>Edit or remove your birth kit at any time directly from your account.</li>
			</ol>
		</div>

		<!-- Edit Section -->
		<div class="mb-10">
			<h2 class="text-xl font-bold mb-4">🔄 NEW! - Edit Birth Kits Directly</h2>
			<p class="mb-6">
				Existing midwives can now <span class="font-semibold">edit your kit anytime</span> from your account page — add, remove and change quantities on default and
				optional items as your supply needs evolve. No need to call or email — our website gives you full control!
			</p>
			<p class="mb-6">
				Once you are logged in, <router-link to="/categories/midwife-birth-kits/" class="text-ihh-dark-salmon hover:underline">navigate</router-link> to your birth kit
				page and click "Claim My Kit" to get started.
			</p>
			<p class="mb-8">
				If you have any questions or want help building your kit, we're here for you! Reach out to our team
				<router-link to="/help-center" class="text-ihh-dark-salmon hover:underline">here</router-link>.
			</p>
		</div>

		<!-- CTA Button -->
		<div class="text-center mt-8">
			<router-link
				to="/account/birth-kits"
				class="bg-ihh-dark-salmon hover:bg-ihh-salmon text-ihh-white font-semibold py-3 px-8 rounded-lg text-lg transition-colors duration-200 inline-block"
			>
				Manage Your Birth Kits
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NewBirthKitSetup',
	data() {
		return {}
	},
	methods: {},
}
</script>

<style scoped></style>
